import { useMemo, useCallback } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { Feature } from 'components/common/feature/Feature';
import { NsxAddressSelector } from 'components/common/nsx-address-selector/NsxAddressSelector';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';
import { NsCard } from 'components/common/ns-card/NsCard';
import { useNavigation } from 'hooks/useNavigation';
import { ToggleJourney } from 'components/app/routes/ToggleJourney';
import { selectors as meterTypeSelectors } from 'state/meter-type/meter-type-slice';
import { useQueryParam } from 'hooks/useQueryParams';
import { HighDemandAlert } from 'components/common/error/components/HighDemandAlert';
import { NsContent } from 'components/common/ns-content/NsContent';
import { NsForm } from 'components/common/ns-form/NsForm';
import EnergySavingFact from 'components/common/energy-saving-fact/EnergySavingFact';

const { selectIsLoading: selectIsLoadingMeterType } = meterTypeSelectors;

export const testId = 'directSalesTestId';

export const DirectSalesContent = () => {
  const { allowJourneyDefault } = useFlags();
  const defaultPostcode = useQueryParam('postcode');
  const isLoadingMeterType = useSelector(
    selectIsLoadingMeterType,
    shallowEqual
  );
  const { next, eventTypes } = useNavigation();

  const handleGoNext = useCallback(() => {
    next({ eventType: eventTypes.NEXT });
  }, [next, eventTypes.NEXT]);

  return useMemo(() => {
    if (isLoadingMeterType) {
      return <NsStopgap />;
    }

    return (
      <Feature
        feature={allowJourneyDefault}
        inactiveComponent={<ToggleJourney off />}
      >
        <div data-testid={testId}>
          <NsCard>
            <NsContent>
              <HighDemandAlert />

              <NsForm>
                <NsContent>
                  <p>
                    Join the UK&apos;s leading energy supplier. You&apos;ll find
                    our cheapest gas and electricity tariffs right here.
                  </p>
                </NsContent>

                <NsxAddressSelector
                  handleGoNext={handleGoNext}
                  defaultPostcode={defaultPostcode}
                />
              </NsForm>
              <EnergySavingFact
                fact={
                  <>
                    Our latest fixed tariff is below the price cap so
                    you&apos;ll save money when you switch today. There&apos;s
                    other options too, like EV and Prepayment tariffs.
                  </>
                }
              />
            </NsContent>
          </NsCard>
        </div>
      </Feature>
    );
  }, [allowJourneyDefault, isLoadingMeterType, defaultPostcode, handleGoNext]);
};

export default DirectSalesContent;
